import { DsButton, DsInput } from "../../../design-system";

/**
 * Shared list toolbar for Employee Settings → Policies (all four policy types).
 * Flat strip (no card chrome) + DsButton / DsInput.
 * Controls stay on one row; DsInput base `w-full` is constrained via wrapper.
 */
export default function PolicyListToolbar({
  title,
  newLabel,
  onNew,
  onPrint,
  searchValue,
  onSearchChange,
  showInactive,
  onToggleInactive,
  rolesSlot = null,
  searchPlaceholder = "Search policy by name...",
}) {
  return (
    <div className="mb-3 flex shrink-0 flex-nowrap items-center justify-between gap-3 border-b border-[hsl(var(--ds-border))] pb-3">
      <h3 className="ds-h4 shrink-0 whitespace-nowrap text-[hsl(var(--ds-fg))]">{title}</h3>
      <div className="flex shrink-0 flex-nowrap items-center gap-2">
        {rolesSlot}
        {typeof onPrint === "function" && (
          <DsButton type="button" variant="outline" size="sm" onClick={onPrint}>
            Print all policies
          </DsButton>
        )}
        <div className="w-56 shrink-0">
          <DsInput
            type="search"
            value={searchValue}
            onChange={onSearchChange}
            placeholder={searchPlaceholder}
            className="!w-full"
            aria-label="Search policies"
          />
        </div>
        <DsButton type="button" variant="outline" size="sm" onClick={onToggleInactive}>
          {showInactive ? "Show Active" : "Show Inactive"}
        </DsButton>
        <DsButton type="button" variant="primary" size="sm" onClick={onNew}>
          {newLabel}
        </DsButton>
      </div>
    </div>
  );
}
